var sideboxTopOffset = 8;
export var agencyBrandingHeaderDesktopHeight = 66;
export var agencyBrandingHeaderTabletHeight = 44;
export var getSideboxTopEdgeOffset = _ref => {
  var showAgencyBrandingHeader = _ref.showAgencyBrandingHeader,
    desktop = _ref.desktop;
  if (showAgencyBrandingHeader) {
    return sideboxTopOffset + (desktop ? agencyBrandingHeaderDesktopHeight : agencyBrandingHeaderTabletHeight);
  }
  return sideboxTopOffset;
};